var header = {
    height: window.innerWidth < 570 ? "96px" : "48px",
    lineHeight: "46px",
    padding: 0,
    // background: "#001529",
    background: "white",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 999,
};
var layout = {
    width: "100%",
    minHeight: "100vh",
    paddingTop: header.height,
};
var layoutWithoutHeader = {
    width: "100%",
    minHeight: "100vh",
};
var content = {
    position: "relative",
    height: "100%",
    width: "100%",
    display: "flex",
    alignSelf: "stretch",
};
var menu = {
    height: "40px",
    lineHeight: "40px",
    padding: "0 7px",
    background: "#ffffff",
    borderBottom: "1px solid #f0f0f0",
};
var footer = {
    padding: 0,
    height: "40px",
};
var footerCopyright = {
    textAlign: "center",
    background: "rgba(255,255,255,1.05)",
    fontSize: "13px",
    padding: 9,
    height: "40px",
    color: "darkgray",
};
export default {
    layout: layout,
    layoutWithoutHeader: layoutWithoutHeader,
    content: content,
    header: header,
    menu: menu,
    footer: footer,
    footerCopyright: footerCopyright,
};
//# sourceMappingURL=data:application/json;base64,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